import React from 'react';
import Icon from '../../../components/AppIcon';

const BusinessValueSection = () => {
  const valueCards = [
    {
      icon: 'Clock',
      title: 'Avoid the 4-hour minimum',
      cost: '~$700+',
      description: 'Typical forensic engineering rates start around ~$175/hr and may require a 4-hour minimum → ~$700+ just to begin (before travel/testing).',
      microCopy: 'Get a preliminary read before committing to multi-hour minimums.',
      iconBg: 'bg-blue-500/10',
      iconColor: 'text-blue-500'
    },
    {
      icon: 'TrendingUp',
      title: 'Expert witness time adds up fast',
      cost: '$1,650–$3,500',
      description: 'Fire expert witness fees are often quoted around: $275/hr (review) • $350/hr (deposition / court). Even 6–10 hours of review + calls can be ~$1,650–$3,500 before testimony.',
      microCopy: 'Use AI to triage first—retain humans only when it\'s worth it.',
      iconBg: 'bg-amber-500/10',
      iconColor: 'text-amber-500'
    },
    {
      icon: 'FileText',
      title: 'Depositions often come with minimums + prepay',
      cost: '~$1,400',
      description: 'Some fire investigation firms publish $350/hr deposition fees with a 4-hour minimum (prepaid) → ~$1,400 minimum for deposition time alone.',
      microCopy: 'Decide whether to litigate before deposition costs lock in.',
      iconBg: 'bg-purple-500/10',
      iconColor: 'text-purple-500'
    },
    {
      icon: 'DollarSign',
      title: 'Expert engagement can be a $3k–$15k line item',
      cost: '$3,000–$15,000+',
      description: 'Civil litigation cost breakdowns commonly budget ~$3,000–$15,000+ per expert for investigation/reports/testimony (varies widely by case).',
      microCopy: 'Validate viability early—avoid spending big on weak cases.',
      iconBg: 'bg-emerald-500/10',
      iconColor: 'text-emerald-500'
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Smart Triage Before Big Commitments
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Know the viability of your case before expert fees escalate. Make informed decisions early.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {valueCards?.map((card, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-elevation-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`w-12 h-12 ${card?.iconBg} rounded-lg flex items-center justify-center mb-4`}>
                <Icon name={card?.icon} size={24} className={card?.iconColor} />
              </div>

              <h3 className="text-lg font-semibold text-foreground mb-2">
                {card?.title}
              </h3>

              <div className="text-2xl font-bold text-primary mb-3">
                {card?.cost}
              </div>

              <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                {card?.description}
              </p>

              <div className="pt-4 border-t border-border">
                <p className="text-xs font-medium text-foreground italic">
                  {card?.microCopy}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 text-success rounded-lg">
            <Icon name="CheckCircle" size={20} />
            <span className="text-sm md:text-base font-medium">
              Start with AI triage for a fraction of the cost
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessValueSection;